




































































































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';

import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingReviewImage from '../../../components/parking-review-image/index.vue';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

import PlateInput from '../../../components/plate-input/index.vue';
// 接口
import { queryOrderEnterList, exportOrderEnter, submitOrderEnterEdit } from '../../../api/order-management';
import * as routeNames from '../router-names';
import Utils from '@root/utils/common';
import { AuthTypes, authTypesMap, carTypesMap, enterCarMap } from '../../../types/order-management/dictionaries';
import { API_SERVER } from '@root/common/config';
import moment from 'moment';
import { Getter } from 'vuex-class';
import ShowImg from '@/components/show-img/index.vue';
import { isShiDaill } from '@root/utils/env';
@Component({
  name: 'EnterCarList',
  components: {
    ParkingReviewImage,
    ParkingLotSearch,
    PlateInput,
    ShowImg
  }
})
export default class EnterCarList extends Mixins(TableMixin, TableWidthMixin) {
  private imgBaseImg = `${API_SERVER.imgBaseUrl}`;
  private defaultImg = `${API_SERVER.defaultImg}`;

  plateInputModel = false;
  // carTypeList = Utils.toLabelVal(enterCarMap)
  // @Getter('dictionaries/allDictionaries')
  // allDictionaries?: any
  get carTypeList() {
    console.log(
      'this.$store.state.dictionaries',
      this.$store.state.dictionaries.allDictionaries.cp_auth_allow_rule_allow_rule
    );
    return Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_order_enter_record_car_type || {});
  }
  carTypesMap = this.$store.state.dictionaries.allDictionaries.cp_order_enter_record_car_type || {};
  // 车辆类型字典项
  // 车型
  @Getter('dictionaries/orderAuthType')
  orderAuthType?: object;
  get vehicleTypeList() {
    // 车辆类型
    return Utils.toLabelVal(this.orderAuthType);
  }

  get enterEventList() {
    return Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_order_enter_record_enter_event || {});
  }

  AuthTypes = AuthTypes;
  // 查看图片弹框
  showReviewImgModel: boolean = false;
  // 点击 查看 修正  所使用的数据
  reviewModelDate: {} = {};
  reviewImgModel: {} = {};
  // 修正 弹框
  showCorrectionModel: boolean = false;
  private tableLoading: boolean = false;
  private confirmLoading: boolean = false;
  isshidaill: boolean = isShiDaill;

  get defaultTime() {
    if (this.filterParam.startTime && this.filterParam.endTime) {
      return [
        this.moment(this.filterParam.startTime, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.endTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.startTime) {
      return [this.moment(this.filterParam.startTime, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }

  set defaultTime(val: any) {}

  // correction 修正上传数据
  private correction: any = {
    afterPlate: '',
    afterCarType: ''
  };

  get afterPlate() {
    return this.correction.afterPlate;
  }
  set afterPlate(val: string) {
    this.correction.afterPlate = val.toLocaleUpperCase();
  }

  clear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkIds: defaultParkIdList, // 车场ID集合,多车场逗号分隔
      plateHead: '', // 车牌头
      plateTail: '',
      startTime: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00', // 开始时间
      endTime: moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59', // 结束时间
      authTypes: [], // 车辆类型,多个类型逗号分隔（00：临停小车 01：临停大车 02：产权车 03：月卡车）
      carTypes: '', // 车型,多个类型逗号分隔,01：小车，02：大车
      enterWay: [], // 入场方式
      enterTimeOrderBy: '',
      parkingTimeOrderBy: '',
      plateMobile: ''
    };
    this.search();
  }

  private filterParam: any = {
    parkIds: [], // 车场ID集合,多车场逗号分隔
    plateHead: '', // 车牌头
    plateTail: '',
    startTime: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00', // 开始时间
    endTime: moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59', // 结束时间
    authTypes: [], // 车辆类型,多个类型逗号分隔（00：临停小车 01：临停大车 02：产权车 03：月卡车）
    carTypes: '', // 车型,多个类型逗号分隔,01：小车，02：大车
    enterWay: [], // 入场方式
    enterTimeOrderBy: '',
    parkingTimeOrderBy: '',
    plateMobile: ''
  };

  async created() {
    setTimeout(() => {
      this.fetchTableData();
    }, 0);
  }

  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }

  /**
   * 获取列表数据
   */
  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        parkIds,
        plateHead,
        plateTail,
        startTime,
        endTime,
        authTypes,
        carTypes,
        enterWay,
        enterTimeOrderBy,
        parkingTimeOrderBy,
        plateMobile
      } = this.filterParam;
      const { status, msg, code, data } = await queryOrderEnterList({
        parkIds: '' + parkIds, // 车场ID集合,多车场逗号分隔
        startTime, // 开始时间
        endTime, // 结束时间
        plateHead,
        plateTail,
        authTypes: '' + authTypes, // 车辆类型,多个类型逗号分隔（00：临停小车 01：临停大车 02：产权车 03：月卡车）
        carTypes: '' + carTypes === '00' ? '02' : '' + carTypes,
        currPage: this.current,
        pageSize: this.pageSize,
        enterWay: '' + enterWay,
        enterTimeOrderBy,
        parkingTimeOrderBy,
        plateMobile
      });
      if (data) {
        const { pageSize, currPage, totalNum, totalPage, datas } = data;
        this.tableData = datas;
        this.total = Number(totalNum);
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  private async handleOrderEnterCorrection() {
    try {
      this.confirmLoading = true;
      // @ts-ignore
      let { plate, carType, pkOrderId, parkId } = this.reviewImgModel;
      let { afterPlate, afterCarType } = this.correction;
      for (let key in this.carTypesMap) {
        if (this.carTypesMap[key] === carType) {
          carType = key;
        }
      }
      for (let key in this.carTypesMap) {
        if (this.carTypesMap[key] === afterCarType) {
          afterCarType = key;
        }
      }
      // if (plate === afterPlate) {
      //   afterPlate = '';
      // }
      // if (carType === afterCarType) {
      //   afterCarType = '';
      // }
      plate = plate.toLocaleUpperCase();
      const { status, code, msg, data } = await submitOrderEnterEdit({
        beforePlate: plate,
        beforeCarType: carType,
        pkOrderId,
        parkId,
        afterPlate,
        afterCarType
      });
      if (status === '9999') {
        this.$message.success(msg);
        this.fetchTableData();
        this.showCorrectionModel = false;
      } else {
        this.$message.error(msg);
      }
      this.confirmLoading = false;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('submitOrderEnterEdit 修正错误');
    } finally {
      this.confirmLoading = false;
    }
  }

  private moment = moment;

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  exportLoading = false;
  private async download() {
    if (this.exportLoading) return;
    // if (this.total > 50000) {
    //   this.exportLoading = false
    //   return this.$message.error('导出最大只能支持五万条')
    // }
    this.exportLoading = true;
    try {
      const {
        parkIds,
        plateHead,
        plateTail,
        startTime,
        endTime,
        authTypes,
        carTypes,
        enterWay,
        enterTimeOrderBy,
        parkingTimeOrderBy,
        plateMobile
      } = this.filterParam;
      await exportOrderEnter(
        {
          parkIds: '' + parkIds, // 车场ID集合,多车场逗号分隔
          startTime, // 开始时间
          endTime, // 结束时间
          plateHead,
          plateTail,
          authTypes: '' + authTypes, // 车辆类型,多个类型逗号分隔（00：临停小车 01：临停大车 02：产权车 03：月卡车）
          carTypes: '' + carTypes === '00' ? '02' : '' + carTypes,
          enterWay: '' + enterWay,
          enterTimeOrderBy,
          parkingTimeOrderBy,
          plateMobile
        },
        '在场车辆'
      );
    } catch (e) {
      console.log('exportOrderEnter', '导出失败');
    } finally {
      this.exportLoading = false;
    }
  }

  /**
   * 车牌号组件发生变化
   */
  plateChange([plateHead, plateTail]: any, b: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  tableData: any[] = [];

  // 入场时间改变
  onEnterTimeChange(date: any, dateString: any) {
    let [startTime, endTime] = dateString;
    this.filterParam.startTime = startTime;
    this.filterParam.endTime = endTime;
  }

  // 查看图片
  reviewImages(record: {}) {
    this.reviewModelDate = record;
    this.showReviewImgModel = true;
  }

  // 修正
  showCorrection(record: any) {
    this.reviewImgModel = record;
    this.correction.afterCarType = record.carType;
    this.correction.afterPlate = record.plate;
    this.showCorrectionModel = true;
  }

  // 跳转详情
  toDetail(pkOrderId: any, parkId: any) {
    this.$router.push({
      name: routeNames.ENTER_CAR_DETAIL,
      params: {
        pkOrderId,
        parkId
      }
    });
  }

  get tableColums() {
    if (this.isshidaill)
      return [
        {
          title: '序号',
          width: 100,
          customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
        },
        {
          title: '车场名称',
          dataIndex: 'parkName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '车牌号',
          dataIndex: 'plate',
          width: 140
        },
        {
          title: '车型',
          dataIndex: 'carType',
          width: 140,
          scopedSlots: { customRender: 'text-ellipse' }
        },
        {
          title: '入场时间',
          dataIndex: 'enterTime',
          width: 240
        },
        {
          title: '入场通道',
          dataIndex: 'enterChannelName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '入场方式',
          dataIndex: 'enterEventName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '停车时长',
          dataIndex: 'parkingTime',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '车辆类型',
          dataIndex: 'authTypeName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '停放区域',
          dataIndex: 'areaName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '停车订单号',
          dataIndex: 'pkOrderId',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '手机号',
          dataIndex: 'plateMobile',
          width: 140,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '查看图片',
          dataIndex: 'image',
          scopedSlots: { customRender: 'image' },
          fixed: 'right',
          width: 100
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          width: 180
        }
      ];
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 140,
        scopedSlots: { customRender: 'click-to-detail' }
      },
      {
        title: '车型',
        dataIndex: 'carType',
        width: 140,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '入场时间',
        dataIndex: 'enterTime',
        width: 240,
        sortable: true
      },
      {
        title: '入场通道',
        dataIndex: 'enterChannelName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '入场方式',
        dataIndex: 'enterEventName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '停车时长',
        dataIndex: 'parkingTime',
        width: 180,
        sortable: true,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车辆类型',
        dataIndex: 'authTypeName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '停放区域',
        dataIndex: 'areaName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '停车订单号',
        dataIndex: 'pkOrderId',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '查看图片',
        dataIndex: 'image',
        scopedSlots: { customRender: 'image' },
        fixed: 'right',
        width: 100
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
        width: 180
      }
    ];
  }

  reviewColums = [
    {
      imageSrc: 'image',
      data: [
        {
          label: '车牌',
          dataIndex: 'plate'
        },
        {
          label: '入场时间',
          dataIndex: 'enterTime'
        },
        {
          label: '入场位置',
          dataIndex: 'enterChannelName'
        }
      ]
    }
  ];
  getEnterImg() {
    window.open((this.$refs.enterImg as any).src);
  }
  // 表头筛选
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }
}
